var _mask, _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecomended(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_393_8432",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.94508 0 0 8.94586 0 20C0 31.0549 8.94586 40 20 40C31.0549 40 40 31.0541 40 20C40 8.94508 31.0541 0 20 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.94508 0 0 8.94586 0 20C0 31.0549 8.94586 40 20 40C31.0549 40 40 31.0541 40 20C40 8.94508 31.0541 0 20 0Z",
    fill: "#1A89A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20C1 9.49812 9.49739 1 20 1V-1C8.39277 -1 -1 8.3936 -1 20H1ZM20 39C9.49812 39 1 30.5026 1 20H-1C-1 31.6072 8.3936 41 20 41V39ZM39 20C39 30.5019 30.5026 39 20 39V41C31.6072 41 41 31.6064 41 20H39ZM20 1C30.5019 1 39 9.49739 39 20H41C41 8.39277 31.6064 -1 20 -1V1Z",
    fill: "white",
    mask: "url(#path-1-inside-1_393_8432)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_393_8432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.314 23.8443C25.314 26.4403 23.6938 28.6571 21.4107 29.5454H24.5503C26.0697 28.1188 27.019 26.0929 27.019 23.8443C27.019 20.0975 24.3832 16.9658 20.8645 16.2021L19.3345 17.7322C22.6517 17.8064 25.314 20.5138 25.314 23.8443Z",
    fill: "#8DC5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6898 31.6672H12.8405C12.5488 31.6672 12.3101 31.4286 12.3101 31.1369V30.0762C12.3101 29.7845 12.5488 29.5459 12.8405 29.5459H27.6898C27.9815 29.5459 28.2202 29.7845 28.2202 30.0762V31.1369C28.2202 31.4286 27.9815 31.6672 27.6898 31.6672Z",
    fill: "#8DC5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.145 15.4193L20.3732 10.6475L12.8207 18.2L17.5925 22.9718L25.145 15.4193Z",
    fill: "#F9B42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5239 12.1945L23.5989 9.26953L21.2345 11.6339L24.1595 14.5589L26.5239 12.1945Z",
    fill: "#E6F3F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1257 16.2712L19.5201 10.6655C19.3504 10.4958 19.3504 10.2227 19.5201 10.0556L19.719 9.85677C19.8887 9.68707 20.1618 9.68707 20.3288 9.85677L25.9345 15.4624C26.1042 15.6321 26.1042 15.9052 25.9345 16.0723L25.7356 16.2712C25.5685 16.4382 25.2954 16.4382 25.1257 16.2712Z",
    fill: "#8DC5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9103 12.9091L22.8824 8.88124C22.7843 8.78313 22.7843 8.62138 22.8824 8.52327L22.9991 8.40659C23.0972 8.30848 23.2589 8.30848 23.357 8.40659L27.3849 12.4345C27.483 12.5326 27.483 12.6943 27.3849 12.7925L27.2683 12.9091C27.1701 13.0099 27.0084 13.0099 26.9103 12.9091Z",
    fill: "#8DC5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5101 23.8874L11.9071 18.2817C11.7374 18.112 11.7374 17.8389 11.9071 17.6719L12.106 17.473C12.2757 17.3033 12.5488 17.3033 12.7159 17.473L18.3215 23.0786C18.4912 23.2483 18.4912 23.5214 18.3215 23.6885L18.1226 23.8874C17.9529 24.0544 17.6798 24.0544 17.5101 23.8874Z",
    fill: "#8DC5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8204 25.8601H12.9863C12.7593 25.8601 12.5753 25.6761 12.5753 25.4491C12.5753 25.2221 12.7593 25.0381 12.9863 25.0381H25.8204C26.0474 25.0381 26.2314 25.2221 26.2314 25.4491C26.2314 25.6761 26.0474 25.8601 25.8204 25.8601Z",
    fill: "#8DC5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3865 30.3416C23.192 30.3416 23.845 29.6887 23.845 28.8832C23.845 28.0778 23.192 27.4248 22.3865 27.4248C21.5811 27.4248 20.9281 28.0778 20.9281 28.8832C20.9281 29.6887 21.5811 30.3416 22.3865 30.3416Z",
    fill: "#D7F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3865 29.8555C22.924 29.8555 23.3597 29.4198 23.3597 28.8823C23.3597 28.3449 22.924 27.9092 22.3865 27.9092C21.8491 27.9092 21.4134 28.3449 21.4134 28.8823C21.4134 29.4198 21.8491 29.8555 22.3865 29.8555Z",
    fill: "#0C6784"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_393_8432",
    x: -10.2202,
    y: -13.667,
    width: 60.4404,
    height: 67.334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.403922 0 0 0 0 0.517647 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_393_8432"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_393_8432",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecomended);
export default __webpack_public_path__ + "static/media/recomended.1f08f743.svg";
export { ForwardRef as ReactComponent };